import { render } from "./DataViewer.vue?vue&type=template&id=34ac75da&scoped=true"
import script from "./DataViewer.vue?vue&type=script&lang=js"
export * from "./DataViewer.vue?vue&type=script&lang=js"

import "./DataViewer.vue?vue&type=style&index=0&id=34ac75da&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-34ac75da"

export default script